export const ProviderReducer =
  (
    ParentProvider: React.FC<React.PropsWithChildren<unknown>>,
    ChildProvider: React.FC<React.PropsWithChildren<unknown>>
  ) =>
  ({ children }: React.PropsWithChildren<{}>) =>
    (
      <ParentProvider>
        <ChildProvider>{children}</ChildProvider>
      </ParentProvider>
    );
